module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-popover', {
    attrs: {
      "title": _vm.items.project_type == 'service' ? '洗护美容结算' : '商品结算',
      "placement": "left",
      "trigger": "click",
      "disabled": _vm.use_lock,
      "width": "500",
      "height": "400"
    },
    on: {
      "hide": _vm.hidPopover
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "goods_info"
  }, [_c('span', {
    staticClass: "goods_name"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.items.project_name) + "\n\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "goods_class"
  }, _vm._l((_vm.items.skuList), function(skuRow, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "size": "mini"
      }
    }, [_vm._v(_vm._s(skuRow))])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "goods_price"
  }, [_vm._v("\n\t\t\t￥" + _vm._s(_vm.items.project_original_price) + " x " + _vm._s(_vm.quantity) + "\n\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "goods_total_price"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.items.project_subtotal_amount) + "\n\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "selWarpper"
  }, [(_vm.items.project_original_price > 0) ? [(_vm.app_member_price_discount_status && _vm.is_gifts != 1) ? _c('div', {
    staticClass: "goodCoupon"
  }, [_c('span', {
    staticClass: "coupon1"
  }, [_vm._v("会员价")]), _vm._v(" "), _c('span', [(_vm.app_member_price_discount_status) ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "选择会员折扣",
      "size": "small"
    },
    model: {
      value: (_vm.use_member_price),
      callback: function($$v) {
        _vm.use_member_price = $$v
      },
      expression: "use_member_price"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不使用",
      "value": "0"
    }
  }, [_vm._v("不使用")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.items.app_member_price.discount_name,
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.items.app_member_price.group_name) + _vm._s(_vm.items.app_member_price.discount_name))])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.items.project_type == 'service' && _vm.is_gifts != 1) ? _c('div', {
    staticClass: "goodCoupon"
  }, [_c('span', {
    staticClass: "coupon1"
  }, [_vm._v("服务卡")]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "选择服务卡"
    },
    on: {
      "change": _vm.cardChange
    },
    model: {
      value: (_vm.use_user_card),
      callback: function($$v) {
        _vm.use_user_card = $$v
      },
      expression: "use_user_card"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不使用",
      "value": "0"
    }
  }, [_vm._v("不使用")]), _vm._v(" "), _vm._l((_vm.items.user_card_service), function(item) {
    return _c('el-option', {
      key: item.user_card_id,
      attrs: {
        "label": item.card_name,
        "value": item.user_card_id
      }
    })
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.use_user_card == 0) ? _c('div', {
    staticClass: "goodCoupon"
  }, [_c('span', {
    staticClass: "coupon1"
  }, [_vm._v("商品优惠")]), _vm._v(" "), (_vm.is_gifts == 1) ? _c('span', [_vm._v("\n\t\t\t\t\t商品赠送，免单！\n\t\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.channelPush(_vm.items, _vm.tableKey)
      }
    }
  }, [_vm._v("取消赠送")])], 1) : [(_vm.discount >= 1) ? _c('span', [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.ishow(_vm.items, _vm.tableKey)
      }
    }
  }, [_vm._v("改价优惠")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.isPush(_vm.items, _vm.tableKey)
      }
    }
  }, [_vm._v("赠送优惠")])], 1) : _c('span', [_c('span', {
    staticClass: "input"
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "text",
      "size": "medium",
      "placeholder": "请输入金额",
      "oninput": "this.value=(this.value.match(/^\\d*(\\.?\\d{0,2})/g)[0]) || null"
    },
    on: {
      "blur": function($event) {
        return _vm.discountItem(_vm.items, 1, $event)
      },
      "focus": function($event) {
        return _vm.clearVal($event)
      }
    },
    model: {
      value: (_vm.discount_amount),
      callback: function($$v) {
        _vm.discount_amount = $$v
      },
      expression: "discount_amount"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inliin-block",
      "width": "80px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "text-align": "center",
      "line-height": "50px"
    },
    attrs: {
      "src": require("../../assets/image/goto.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inliin-block",
      "width": "140px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "text",
      "size": "medium",
      "placeholder": "请输入比例",
      "oninput": "this.value=(this.value.match(/^\\d*(\\.?\\d{0,2})/g)[0]) || null;if(value>=100)value=100;if(value<=0.01)value=0.01"
    },
    on: {
      "blur": function($event) {
        return _vm.discountItem(_vm.items, 2, $event)
      },
      "focus": function($event) {
        return _vm.clearVal($event)
      }
    },
    model: {
      value: (_vm.discount_rate),
      callback: function($$v) {
        _vm.discount_rate = $$v
      },
      expression: "discount_rate"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("%")])])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.channelShow(_vm.items, _vm.tableKey)
      }
    }
  }, [_vm._v("取消")])], 1)]], 2) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "goodCoupon"
  }, [_c('span', {
    staticClass: "coupon1"
  }, [_vm._v("销售员")]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "选择销售员",
      "size": "small"
    },
    model: {
      value: (_vm.merchant_uid),
      callback: function($$v) {
        _vm.merchant_uid = $$v
      },
      expression: "merchant_uid"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "请选择",
      "value": "0"
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.salesManList), function(saleItem) {
    return _c('el-option', {
      key: saleItem.uid,
      attrs: {
        "label": saleItem.realname,
        "value": saleItem.uid
      }
    })
  })], 2)], 1)]), _vm._v(" "), (_vm.items.is_goods == false) ? _c('div', {
    staticClass: "goodCoupon"
  }, [_c('span', {
    staticClass: "coupon1"
  }, [_vm._v("服务员")]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "选择服务员"
    },
    model: {
      value: (_vm.waiter_uid),
      callback: function($$v) {
        _vm.waiter_uid = $$v
      },
      expression: "waiter_uid"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "请选择",
      "value": "0"
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.salesManList), function(saleItem) {
    return _c('el-option', {
      key: saleItem.uid,
      attrs: {
        "label": saleItem.realname,
        "value": saleItem.uid
      }
    })
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btnSub"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.cancelItemUpdate(_vm.items, _vm.tableKey)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.updateProjectItem(_vm.items, _vm.tableKey)
      }
    }
  }, [_vm._v("确认")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        return _vm.handelListSelected(_vm.items, _vm.tableKey)
      }
    },
    slot: "reference"
  }, [_c('div', {
    staticClass: "leftImg"
  }, [(!_vm.use_lock) ? _c('i', {
    staticClass: "el-icon-d-arrow-left",
    staticStyle: {
      "color": "#FF700B"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item-right-main"
  }, [_c('div', {
    staticClass: "item-right-main-top"
  }, [_c('div', {
    staticClass: "top-goodsname"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.items.project_name) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "top-goodsclass"
  }, _vm._l((_vm.items.skuList), function(skuRow, index) {
    return _c('el-tag', {
      key: index,
      staticStyle: {
        "margin-right": "2px"
      },
      attrs: {
        "size": "mini"
      }
    }, [_vm._v(_vm._s(skuRow))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "top-goodsnum",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.numberStop.apply(null, arguments)
      }
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "mini",
      "min": 1,
      "max": 100,
      "precision": 0,
      "disabled": !['goods', 'service'].includes(_vm.items.project_type)
    },
    on: {
      "change": function($event) {
        return _vm.onNumChange($event, _vm.items.cart_id)
      }
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "top-goodsprice"
  }, [_vm._v(_vm._s(_vm.itemTotal))]), _vm._v(" "), _c('div', {
    staticClass: "top-goodsbutton"
  }, [(_vm.isShowDel) ? _c('el-button', {
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onDelItem(_vm.items.cart_id)
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-right-main-footer"
  }, [_c('div', {
    staticClass: "main-footer-right"
  }, [_c('div', [_vm._v("销售员：\n\t\t\t\t\t\t"), _vm._l((_vm.salesManList), function(salesmanRow, index) {
    return _c('span', {
      key: index
    }, [(salesmanRow.uid == _vm.items.merchant_uid) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(salesmanRow.realname) + "\n\t\t\t\t\t\t\t")]) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.items.is_goods == false) ? _c('div', [_vm._v("\n\t\t\t\t\t\t服务员：\n\t\t\t\t\t\t"), _vm._l((_vm.salesManList), function(salesmanRow, index) {
    return _c('span', {
      key: index
    }, [(salesmanRow.uid == _vm.items.waiter_uid) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(salesmanRow.realname) + "\n\t\t\t\t\t\t\t")]) : _vm._e()])
  })], 2) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b11554f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/popItem.vue
// module id = 3504
// module chunks = 103